import React, { createRef, MouseEvent, useLayoutEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { IOrder } from '../../lib/ssp';
import { getPathToOrderDetailsPage } from '../../lib/ssp/utils/routesUtil';
import { useInterfaceSettings } from '../../providers/InterfaceSettings/useInterfaceSettings';
import Chevron from '../Chevron';
import Fulfillment from '../Fulfillment';
import Price from '../Price';
import OrderTitle from '../self-serve/OrderTitle';

import {
  Container,
  Content,
  Header,
  PageWrapper,
  Segment,
  StyledCollapse,
} from './styled';

export type OrderProps = {
  order: IOrder;
  defaultOpen?: boolean;
};

const Order = ({ order, defaultOpen = false }: OrderProps) => {
  const router = useRouter();
  const uiSettings = useInterfaceSettings();

  const [expanded, setExpanded] = useState(defaultOpen);
  const $orderRef = createRef<HTMLDivElement>();

  useLayoutEffect(() => {
    if (defaultOpen && $orderRef.current) {
      $orderRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultOpen]);

  const showOrderDetails = (e: MouseEvent) => {
    e.stopPropagation();

    router.push(getPathToOrderDetailsPage(order.id));
  };

  return (
    <PageWrapper ref={$orderRef}>
      <Container>
        <Header onClick={() => setExpanded(!expanded)}>
          <OrderTitle order={order} onClick={showOrderDetails} />
          <Segment>
            <Price
              currency={order.total_price_set.presentment_money.currency_code}
              value={(
                parseFloat(order.total_price_set.presentment_money.amount) -
                order.refunded_amount
              ).toString()}
              size="big"
              locale={uiSettings.activeLocale}
            />
            <Chevron facing={expanded ? 'up' : 'down'} />
          </Segment>
        </Header>
        <StyledCollapse isOpened={expanded}>
          <Content>
            {order.fulfillments.map((fulfillment, index) => (
              <Fulfillment
                key={fulfillment.id}
                fulfillment={fulfillment}
                orderId={order.id}
                isLast={index === order.fulfillments.length - 1}
              />
            ))}
          </Content>
        </StyledCollapse>
      </Container>
    </PageWrapper>
  );
};

export default Order;
